export const adaptRequerimientosAdicionalesRI = ({ adicionalRIById }) => {
    return {
        idDatosGeneralesRI: adicionalRIById[0]?.idDatosGeneralesRI,
        requerimientosAdicionales:{
            idComboRIValorReqAdicional: adicionalRIById?.map(option => option.idComboRIValorReqAdicional) || []
        }
    }
}